/** Shown in the snackbar after a successful edit-user save or dismiss */
export const EDIT_USER_SUCCESS_MESSAGE = 'User successfully edited';
